/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { TagsPage } from '@/pages/Tags/TagsPage';

export function TagsRoute() {
  return <TagsPage />;
}
